import { withRouter } from 'react-router';
import { breadcrumbs } from '@inqool/uas-web-core/es/utils';
import Dictionary from '@inqool/uas-web-core/es/components/app/Dictionary';
import { compose, setDisplayName, onlyUpdateForKeys, withProps } from 'recompose';
import * as React from 'react';
import { withClassname } from '@components/hoc/withClassname';
import { WorkPositionsForm } from '@modules/hr-workPositions/WorkPositionsForm';
import { withAdditionalProps } from '@components/hoc/withAdditionalProps';
import { withColumns } from '@components/hoc/withColumns';
import { Agenda } from '@modules/columnSettings/_columnSettingsEnums';
import { ColumnManager } from '@modules/columnSettings/ColumnManager';

export const workPositionsUrl = '/metropolis/api/hr/work-positions';
export const workPositionsLabel = 'Pracovní pozice';
export const workPositionsPath = '/hr/work-positions';
export const workPositionsGridName = 'work-positions-form';
export const WorkPositionsGrid = compose(
  withRouter,
  setDisplayName('WorkPositionsGrid'),
  onlyUpdateForKeys(['url', 'location']),
  breadcrumbs([{ label: workPositionsLabel }]),
  withColumns(Agenda.WORK_POSITIONS),
  withProps(({ columns }) => ({
    name: workPositionsGridName,
    url: workPositionsUrl,
    Form: WorkPositionsForm,
    dialog: false,
    gridProps: {
      columns,
      filterRow: true,
      showCheckboxes: true,
      deleting: true,
      filtering: true,
      locale: 'cz',
      adding: true,
      version: 7,
      ActionBar: () => <ColumnManager agenda={Agenda.WORK_POSITIONS} />
    }
  })),
  withAdditionalProps,
  withClassname({ className: 'mp-grid' })
)(Dictionary);



// WEBPACK FOOTER //
// ./src/modules/hr-workPositions/WorkPositionsGrid.tsx